import styled from 'styled-components'
import { Typography } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

// ─── Note Template Key (tooltip inside TreatmentModal) ───────────────────────

export const NoteTemplateKeyWrapper = styled.div`
    max-width: 360px;
    color: #fff;
`

export const NoteTemplateKeyTitle = styled.strong`
    color: #fff;
`

export const NoteTemplateKeyTemplate = styled.div`
    margin: 6px 0 10px;
    background: rgba(255, 255, 255, 0.12);
    padding: 4px 8px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 12px;
    word-break: break-word;
    color: #fff;
`

export const NoteTemplateKeyTable = styled.table`
    border-collapse: collapse;
    width: 100%;
`

export const NoteTemplateKeyPlaceholderCell = styled.td`
    padding-right: 10px;
    padding-bottom: 3px;
    white-space: nowrap;
    vertical-align: top;
`

export const NoteTemplateKeyCode = styled.code`
    background: rgba(255, 255, 255, 0.15);
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 11px;
    color: #fff;
`

export const NoteTemplateKeyDescCell = styled.td`
    padding-bottom: 3px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
`

export const NoteTemplateKeyIcon = styled(QuestionCircleOutlined)`
    margin-left: 6px;
    color: #7bad7e;
    cursor: pointer;
    font-size: 13px;
`

// ─── Composed Note Preview (shared: TreatmentModal + QueuedPrescription) ─────

/**
 * $compact  — QueuedPrescription variant (lighter bg, tighter padding, no top margin)
 * $accent   — override the left-border accent colour (e.g. red when over limit)
 */
export const ComposedNotePreview = styled.div`
    border-radius: 4px;
    font-size: 12px;
    background: ${({ $compact }) => $compact ? 'rgba(255, 255, 255, 0.5)' : '#f7f8fa'};
    border: 1px solid ${({ $compact }) => $compact ? 'rgba(123, 173, 126, 0.3)' : '#e8e8e8'};
    border-left: 3px solid ${({ $accent }) => $accent || '#7bad7e'};
    padding: ${({ $compact }) => $compact ? '6px 10px' : '8px 12px'};
    margin-top: ${({ $compact }) => $compact ? 0 : '8px'};
`

export const ComposedNoteLabel = styled(Typography.Text)`
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
`

export const ComposedNoteBody = styled.div`
    margin-top: 4px;
    color: #424647;
    word-break: break-word;
`

/** Footer row used in TreatmentModal — flex, space-between. */
export const ComposedNoteFooter = styled.div`
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 11px;
`

/** $color — dynamic remaining-chars colour (grey / orange / red). */
export const ComposedNoteRemaining = styled.span`
    color: ${({ $color }) => $color};
    font-weight: ${({ $bold }) => $bold ? 600 : 400};
`

export const ComposedNoteTotal = styled.span`
    color: #8c8c8c;
`

/**
 * Single-line char count used in QueuedPrescription
 * (no split remaining / total — just "N / MAX chars").
 */
export const ComposedNoteCharCount = styled.div`
    margin-top: 4px;
    color: #8c8c8c;
    font-size: 11px;
`

// ─── TreatmentModal — pharmacy notes without a template suffix ────────────────

/** Shown below the raw textarea when no template suffix is active. */
export const RemainingCount = styled.div`
    text-align: right;
    font-size: 11px;
    margin-top: 2px;
    color: ${({ $color }) => $color};
`
